@import 'styles/mixins';

.container {
  height: 162px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.label {
  @include lg-semibold;
  color: var(--neutral-40);
  margin-top: 12px;
}

.text {
  @include md-regular;
  color: var(--neutral-40);
  margin-top: 2px;
  width: 276px;
}

.icon {
  width: 36px;
  height: 36px;
  background: var(--positive-10);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  path {
    stroke: var(--positive-50);
  }
}
